<template>
  <v-container fluid>
    <div class="text-left">
      <h4 class="pa-0 header-font primary--text mb-2" style="font-size: 22px;">{{ $t("playerRecruitment.radarDescription.basicStatistics.title") }}</h4>
      <div v-for="playerSeason in playerSeasonBasicStats">
        <div class="pb-2 body-1 primary--text" v-html="playerSeason.text"></div>
      </div>
      <h4 class="pa-0 header-font primary--text mt-5" style="font-size: 22px;">{{ $t("playerRecruitment.radarDescription.description") }}</h4>
      <div class="pt-2 body-1 primary--text" v-html="descriptionText"></div>
    </div>
  </v-container>
</template>

<script>
import { round, getFieldPositionIdByDefaultCode } from '../../utils/functions';
import PlayerRadarService from '../../services/player/playerRadar.service';

const PERCENT_OVER_AVERAGE_VALUE = 20;
const MAX_NUMBER_STATS_OVER_MAX_VALUE = 4;
const MAX_NUMBER_STATS_UNDER_MIN_VALUE = 4;
const MAX_NUMBER_STATS_OVER_AVERAGE_VALUE = 4;
const VALUE_OVER_WHICH_JUST_ONE_DECIMAL = 10;

export default {
  name: 'RadarDescription',
  components: {

  },
  data () {
    return {
      descriptionText: "",
      list5BestLeagues: [1, 7, 1923, 4129, 7662],
      categoriesAndStatsMap: {},
      statsOverAverageList: [],
      //Basic Stats (Yellow cards, Red cards, Goals, Assists) of player in that season.
      playerSeasonBasicStats: [],
    }
  },
  props: {
    radarData:{
      type: Object,
      default: null
    },
    //Year of season with more minutes played (To compare with Average of that league)
    seasonMoreMinutesPlayedYear:{
      type: Number,
      default: 0
    },
    leagueIdWithMoreMinutesPlayed:{
      type: Number,
      default: 0
    },
    leagueLabelWithMoreMinutesPlayed:{
      type: String,
      default: ""
    },
    //Seasons selected to get Basic Statistics
    seasonIds:{
      type: Array,
      required: true,
      //default: []
    },
    player:{
      type: Object,
      default: null
    },
    playerProfiles:{
      type: Object,
      default: null
    },
    radarTemplate:{
      type: String,
      default: ""
    },
  },
  watch: {
    radarData(newDataSet,oldDataSet){
      this.getRadarDescriptionBasicStats();
      this.generateRadarDescription();
    },
  },
  created() {
    this.getRadarDescriptionBasicStats();
    this.generateRadarDescription();
  },
  methods: {
    getRadarDescriptionBasicStats: function(){
      if(this.player && !_.isEmpty(this.seasonIds)){
        const fieldPositionId = this.player.fieldPositionId || this.player.pos || this.getFieldPositionIdByDefaultCode(this.player.position);
        PlayerRadarService.getRadarDescriptionBasicStats(_.map(this.seasonIds,(s) => _.split(s,'-')[0]), this.player.playerId, fieldPositionId).then((response) => {
          //Reset playerSeasonBasicStats array
          this.playerSeasonBasicStats.length = 0;
          response.data.forEach((basicStat) => {
            let text;
            //Generate text for goalkeepers
            if(this.player.fieldPositionId === 1){
              text = basicStat.seasonName + " - " + basicStat.minsPlayed + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.minutes") + " - " +
              "(" + basicStat.gamesPlayed + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.games") + ")<br>" + "<b>" + basicStat.goals + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.goalsReceived") +
              "</b> (" + round(basicStat.xG, 2) + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.xGFaced") + ") - " + basicStat.yellowCards + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.yellowCards") + ", "
               + basicStat.redCards + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.redCards");
            }else{
              //Generate text for field players
              text = basicStat.seasonName + " - " + basicStat.minsPlayed + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.minutes") + " - "
             + "(" + basicStat.gamesPlayed + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.games") + ")<br>" + "<b>" + basicStat.goals + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.goals") + "</b> (" + round(basicStat.xG, 2) + " xG)" +
               this.$t("playerRecruitment.radarDescription.conjuction") + "<b>" + basicStat.assists + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.assists") +
               "</b> (" + round(basicStat.xA, 2) + " xA) - " + basicStat.yellowCards + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.yellowCards") + ", "
               + basicStat.redCards + " " + this.$t("playerRecruitment.radarDescription.basicStatistics.redCards");
            }

            this.playerSeasonBasicStats.push({text: text});
           });
        });
      }
    },
    generateRadarDescription(){
      //Clear array with metrics and categories
      this.categoriesAndStatsMap.length = 0;
      this.categoriesAndStatsMap = [];
      //Clear array with metrics and categories
      this.statsOverAverageList.length = 0;
      this.statsOverAverageList = [];
      let someMetricHasAverageValueToZero = false;
      //Clean description rendered before
      this.descriptionText = "";
      if(this.radarData){
        let radarMetrics = this.radarData.statDTOs[0];

        //Just get profile description if de current season of the player is the same year that season selected with more minutes played
        if(this.player && this.player.currentSeasonYear === this.seasonMoreMinutesPlayedYear){
            //Get description by profile
            this.descriptionText = this.playerProfiles.profileId > 0 ? this.getDescriptionsByProfilesAndLanguage(this.playerProfiles.profileId, this.playerProfiles.profileAccuracy, this.playerProfiles.profileShowInRadar,
              this.playerProfiles.secondProfileId, this.playerProfiles.secondProfileAccuracy, this.playerProfiles.secondProfileShowInRadar) : "";
        }

        radarMetrics.forEach((metric, index)=>{

          let percentValueOverAverageValue = 0.0;
          let inTimesOneValue = (metric.valueToShow - metric.minValue) / (metric.maxValue - metric.minValue);

          metric.inTimesOneValue = inTimesOneValue < 1.0 ? inTimesOneValue : 1.0;
          //Check if is a reverse metric (higher value is worse)
          if(metric.isReverse){
              //Check if any metric's value is over maxValue
              if(round(metric.valueToShow, 2) <= metric.maxValue){
                  metric.isPctValueOverMax = (metric.maxValue - metric.valueToShow) / (metric.minValue - metric.maxValue) * 100;
                  metric.isOverMaxValue = true;
              }else if(metric.inTimesOneValue >= 0.7){
                  metric.isOver70Percent = true;
              }else if(round(metric.valueToShow, 2) >= metric.minValue){
                  metric.isPctValueUnderMin = (metric.valueToShow - metric.minValue) / (metric.minValue - metric.maxValue) * 100;
                  metric.isUnderMinValue = true;
              }else if(metric.inTimesOneValue <= 0.3){
                  metric.isUnder30Percent = true;
              }

              //Check if is Over Average Season Value and is NOT Over Max or Over 70% of 5 best leagues
              if(!metric.isOverMaxValue && !metric.isOver70Percent && metric.valueToShow < metric.avgValue){
                  percentValueOverAverageValue = (metric.avgValue - metric.valueToShow) / metric.avgValue * 100;
              }
          }else{
              //Check if any metric's value is over maxValue
              if(round(metric.valueToShow, 2) >= metric.maxValue){
                  metric.isPctValueOverMax = (metric.valueToShow - metric.maxValue) / (metric.maxValue - metric.minValue) * 100;
                  metric.isOverMaxValue = true;
              }else if(metric.inTimesOneValue >= 0.7){
                  metric.isOver70Percent = true;
              }else if(round(metric.valueToShow, 2) <= metric.minValue){
                  metric.isPctValueUnderMin = (metric.minValue - metric.valueToShow) / (metric.maxValue - metric.minValue) * 100;
                  metric.isUnderMinValue = true;
              }else if(metric.inTimesOneValue <= 0.3){
                  metric.isUnder30Percent = true;
              }

              //Check if is Over Average Season Value and is NOT Over Max or Over 70% of 5 best leagues
              if(!metric.isOverMaxValue && !metric.isOver70Percent && metric.valueToShow > metric.avgValue){
                  percentValueOverAverageValue = (metric.valueToShow - metric.avgValue) / metric.avgValue * 100;
              }
          }

          //If League is not one of the 5 Best && metric value is over average season value more than 25%
          if(!this.list5BestLeagues.includes(this.leagueIdWithMoreMinutesPlayed) && percentValueOverAverageValue > PERCENT_OVER_AVERAGE_VALUE){
              //If average value is over 10, then format to one decimal, if not, format to two decimals
              metric.averageValueOfSeason = round(metric.avgValue, metric.avgValue > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2);
              someMetricHasAverageValueToZero = metric.averageValueOfSeason === 0;
              metric.pctOverAverageSeason = percentValueOverAverageValue;
              //...then show in description
              this.statsOverAverageList.push(metric);
          }

          //Order metrics by category. Set category as key and metric (RadarDTO) as value
          if(!this.categoriesAndStatsMap[metric.category]){
            this.categoriesAndStatsMap[metric.category] = [];
          }

          this.categoriesAndStatsMap[metric.category].push(metric);
        });

        let metricsOverMax = radarMetrics.filter(metric => metric.isOverMaxValue);
        let metricsUnderMin = radarMetrics.filter(metric => metric.isUnderMinValue);

        this.descriptionText += metricsOverMax.length > 0 ? this.getDescriptionByTopValues(metricsOverMax) : "";
        this.descriptionText += this.calculatePlayerPerformance(this.playerProfiles.profileId, this.player.fieldPositionId, this.radarTemplate);

        //If there is Over Average Season metrics and all stats have averageValues > 0
        this.descriptionText += this.statsOverAverageList.length > 0 && !someMetricHasAverageValueToZero ? this.getDescriptionOverAverage(this.statsOverAverageList, this.leagueLabelWithMoreMinutesPlayed) : "";
        this.descriptionText += metricsUnderMin.length > 0 ? this.getDescriptionByBottomValues(metricsUnderMin) : "";
      }
    },
    getDescriptionsByProfilesAndLanguage(profileId, profileAccuracy, profileShowInRadar, secondProfileId, secondProfileAccuracy, secondProfileShowInRadar) {
      let description = "";
      let radarDescriptionList;
      //If player has profile and profile is allowed to show in radar description...
      if(profileId > 0 && profileShowInRadar){
          //...then, get all descriptions by profile
          radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription.profiles." + profileId));
          if(radarDescriptionList.length > 0){
              //PlayerId % radarDescriptionList.length to take always the same description to the same player
              description = radarDescriptionList[this.player.playerId % radarDescriptionList.length];
              //If description is not empty, need to add break line
              if(description.length > 0){
                  description += "<br><br>";
              }
          }
      }
      //If player has second profile, second profile is allowed to show in radar description, second profile accuracy is greather than 70% and profile accuracy is less than 90%...
      if(secondProfileId > 0 && secondProfileShowInRadar && secondProfileAccuracy > 70 && profileAccuracy < 90){
        //...then, get all descriptions by profile
        radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription.profiles." + secondProfileId));
        if(radarDescriptionList.length > 0){
            //PlayerId % radarDescriptionList.length to take always the same description to the same player
            description += radarDescriptionList[this.player.playerId % radarDescriptionList.length];
            //If description is not empty, need to add break line
            if(description.length > 0){
                description += "<br><br>";
            }
        }
      }

      return description;
    },
    getDescriptionByTopValues(metricsOverMax){

      let descriptionOverMaxValue = "";
      let numberOfMetricsOverMax = metricsOverMax.length;
      let metricsName = "";
      //Need to take 'e' (conjuction2) instead 'y' (conjuction) when the last stat starts with 'I' (As Interceptions)
      let conjuction = metricsOverMax[numberOfMetricsOverMax - 1].code === "Interceptions" ? this.$t("playerRecruitment.radarDescription.conjuction2") : this.$t("playerRecruitment.radarDescription.conjuction");
      //Get all descriptions for OverMaxValue entry in Dictionary.js
      let radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription.OverMaxValue"));
      if(radarDescriptionList.length > 0 && this.player.playerId){
          //PlayerId % radarDescriptionList.length to take always the same description to the same player
          descriptionOverMaxValue = radarDescriptionList[this.player.playerId % radarDescriptionList.length];
      }

      //If there is 5 or more stats, order descending by pctValueOverMax and just take the first 4
      if(numberOfMetricsOverMax > MAX_NUMBER_STATS_OVER_MAX_VALUE){

        metricsOverMax.sort((a, b) => (a.isPctValueOverMax > b.isPctValueOverMax) ? -1 : 1);
        //Take first 4
        metricsOverMax = metricsOverMax.slice(0, MAX_NUMBER_STATS_OVER_MAX_VALUE);
        numberOfMetricsOverMax = MAX_NUMBER_STATS_OVER_MAX_VALUE;
      }

      metricsOverMax.forEach((metric, index) => {
        if(index < numberOfMetricsOverMax - 2){
            metricsName += "<b>" + this.$t("statsNaming." + metric.code) + "</b>" + ", ";
        }else if(index === numberOfMetricsOverMax - 2){
            //Add conjuction here (second to last)
            metricsName += "<b>" + this.$t("statsNaming." + metric.code) + "</b>" + conjuction;
        }else{
            metricsName += "<b>" + this.$t("statsNaming." + metric.code) + "</b>";
        }
      });

      descriptionOverMaxValue = descriptionOverMaxValue.replace("over_max_metric_name", metricsName);
      descriptionOverMaxValue += ".<br><br>";

      return descriptionOverMaxValue;

    },
    calculatePlayerPerformance(profileId, shortPlayerPosition, radarTemplate){
        let categories = Object.keys(this.categoriesAndStatsMap);
        let arrayRadarCategory = [];
        let description = "";
        let descriptionByMetrics = "";
        let descriptionTotal = "";

        categories.forEach((category, index) => {
          description = "";
          let radarCategoryDTO = this.categoriesAndStatsMap[category].length >= 2 ? this.calculateQuintileOfCategory(this.categoriesAndStatsMap[category], radarTemplate, category) : null;
          if(radarCategoryDTO){
              //For Ball Winning (11) and Holding (12) Midfielders and players with DMC position, just show Association (Id = 15) text if quintile is 4 or 5.
              if((profileId !== 11 && profileId !== 12 && shortPlayerPosition !== 5) || (category !== 15 || radarCategoryDTO.quintile > 3)){
                  //Get all descriptions for OverMaxValue entry in Dictionary.js
                  let radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription." + category + radarCategoryDTO.quintile));
                  if(radarDescriptionList && radarDescriptionList.length > 0 && radarDescriptionList.length < 4){
                      //If is quintile 3, need to replace "over_under_average" word by over or under
                      let overUnderWord = radarCategoryDTO.quintile === 3 && radarCategoryDTO.percentAverageOfCategory > 50.0 ? "over" : "under";
                      //In case is not quintile 3, replace "over_under_average" do nothing (because doesn't exist that word)
                      description = radarDescriptionList[this.player.playerId % radarDescriptionList.length]
                      .replace("over_under_average", this.$t("playerRecruitment.radarDescription." + overUnderWord)).replace("player_position", radarTemplate.toLowerCase());

                      description = description.replace("player_position", radarTemplate.toLowerCase());
                  }

                  descriptionByMetrics = this.getMetricsDescription(radarCategoryDTO);

                  if(description){
                      //Add break line
                      description += descriptionByMetrics ? descriptionByMetrics : "";
                      description += ".<br><br>";
                  }

                  radarCategoryDTO.descriptionByCategory = description;
                  arrayRadarCategory.push(radarCategoryDTO);
              }
          }
        });

        arrayRadarCategory.forEach((radarCategory, index) => {
            descriptionTotal += radarCategory.descriptionByCategory;
        });

        return descriptionTotal;

    },
    calculateQuintileOfCategory(stats, radarPosition, category){
      let radarCategory = {};
      let factor = 1.0;
      let quintile;
      let key;
      let counter = 0.0;
      let metricsToHighlight = [];
      //Set stats category
      radarCategory.category = category;
      //How many stats this category has
      radarCategory.numberOfStats = stats.length;
      stats.forEach((stat, index) => {
        switch (stat.code) {
            case "AerialEfficiency":
            case "TacklesWasDribbled":
                factor = radarPosition === "Defender" ? 2.0 : 1.0;
                break;
            case "PassingFinalThird":
                factor = radarPosition === "Goalkeeper" ? 0.72 : 1.0;
                break;
            case "xGFacedOnTargetEfficiency":
                factor = radarPosition === "Goalkeeper" ? 1.2 : 1.0;
                break;
            case "CompletedCrosses":
            case "Crossing":
                factor = radarPosition === "FullBack" ? 0.75 : 1.0;
                break;
            case "xGEfficiency":
            case "NonPenaltyGoals":
                factor = radarPosition === "Winger" ? 1.33 : radarPosition === "Forward" ? 1.5 : 1.0;
                break;
            default:
                factor = 1.0
                break;
        }

        if(metricsToHighlight.length < stats.length){
            //Check if is under 30%
           if(stat.isUnder30Percent){
             //If is IndividualPressure, take key "Under30PercentIndividualPressure"
             key = stat.code === "IndividualPressure" ? "Under30PercentIndividualPressure" : "Under30Percent";
            }else if(stat.isOver70Percent){ //Check if is over 70%
              //If is IndividualPressure, take key "Over70PercentIndividualPressure"
              key = stat.code === "IndividualPressure" ? "Over70PercentIndividualPressure" : "Over70Percent";
            }

            if(key){
              if(!metricsToHighlight[key]){
                metricsToHighlight[key] = [];
              }
              metricsToHighlight[key].push(stat);
              //Reset the key
              key = "";
            }
        }
        counter += stat.inTimesOneValue * factor;
      });

      //Get quintile
      quintile = Math.trunc(counter/stats.length * 5);
      quintile = quintile < 5 ? quintile + 1 : quintile;
      radarCategory.quintile = quintile <= 0 ? 1 : quintile;
      radarCategory.percentAverageOfCategory = counter/stats.length * 100;
      radarCategory.metricsToHighlight = metricsToHighlight;

      return radarCategory;
    },

    /**
    * Get description of the metrics which value is:
    * - Over max value
    * - Over 70% value
    * - Under 30% value
    * - Under minValue
    */
   getMetricsDescription(radarCategoryDTO) {

       let metricsToHighlight = Object.keys(radarCategoryDTO.metricsToHighlight);
       let descriptionReturn = "";
       let decimals = 2;
       metricsToHighlight.forEach((code, index) => {
         let descriptionByMetrics = "";

         //Get all descriptions for OverMaxValue entry in Dictionary.js
         let radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription." + code));
         if(radarDescriptionList && radarDescriptionList.length > 0){
             descriptionByMetrics = radarDescriptionList[this.player.playerId % radarDescriptionList.length]
         }

         if(descriptionByMetrics && code){
             let metricList = radarCategoryDTO.metricsToHighlight[code];
             let metricsName = "";
             let symbolPercentage = "";
             let keyWordToReplace = "";
             let keyWordValueToReplace = "";
             let metricsValue = "";
             let respectivelyWord = this.$t("playerRecruitment.radarDescription.respectively");
             //Need to take 'e' (conjuction2) instead 'y' (conjuction) when the last stat starts with 'I' (As Interceptions)
             let conjuction = metricList[metricList.length - 1].code === "Interceptions" ? this.$t("playerRecruitment.radarDescription.conjuction2") : this.$t("playerRecruitment.radarDescription.conjuction");

             if(code === "Under30Percent"){
                 keyWordToReplace = "under_30_metric_name";
                 keyWordValueToReplace = "under_30_metric_value";
                 respectivelyWord += ",";
             }else if(code === "Over70Percent"){
                 keyWordToReplace = "over_70_metric_name";
                 keyWordValueToReplace = "over_70_metric_value";
             }

             if(metricList.length === 1){
               //If is not Individual Pressure
               if(metricList[0].code !== "IndividualPressure"){
                   decimals = metricList[0].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
                   metricsValue = "<b>" + round(metricList[0].valueToShow, decimals);
                   metricsValue += (metricList[0].unitCode ? " " + metricList[0].unitCode : "");
                   metricsValue += (metricList[0].isPercentage ? "%" : "") + "</b>";
                   metricsName = "<b>" + this.$t("statsNaming." + metricList[0].code) + "</b>";
               }
             }else if(metricList.length === 2){
               decimals = metricList[0].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
               metricsValue += "<b>" + round(metricList[0].valueToShow, decimals);
               metricsValue += (metricList[0].unitCode ? " " + metricList[0].unitCode : "");
               metricsValue += (metricList[0].isPercentage ? "%" : "") + "</b>" + this.$t("playerRecruitment.radarDescription.conjuction");

               decimals = metricList[1].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
               metricsValue += "<b>" + round(metricList[1].valueToShow, decimals);
               metricsValue += (metricList[1].unitCode ? " " + metricList[1].unitCode : "");
               metricsValue += (metricList[1].isPercentage ? "%" : "") + "</b>";

               metricsName += "<b>" + this.$t("statsNaming." + metricList[0].code) + "</b>" + conjuction;
               metricsName += "<b>" + this.$t("statsNaming." + metricList[1].code) + "</b>";
             }else{
                 decimals = metricList[0].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
                 metricsValue += "<b>" + round(metricList[0].valueToShow, decimals);
                 metricsValue += (metricList[0].unitCode ? " " + metricList[0].unitCode : "");
                 metricsValue += (metricList[0].isPercentage ? "%" : "") + "</b>" + ", ";

                 decimals = metricList[1].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
                 metricsValue += "<b>" + round(metricList[1].valueToShow, decimals);
                 metricsValue += (metricList[1].unitCode ? " " + metricList[1].unitCode : "");
                 metricsValue += (metricList[1].isPercentage ? "%" : "") + "</b>" + this.$t("playerRecruitment.radarDescription.conjuction");

                 decimals = metricList[2].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
                 metricsValue += "<b>" + round(metricList[2].valueToShow, decimals);
                 metricsValue += (metricList[2].unitCode ? " " + metricList[2].unitCode : "");
                 metricsValue += (metricList[2].isPercentage ? "%" : "") + "</b>";

                 metricsName += "<b>" + this.$t("statsNaming." + metricList[0].code) + "</b>" + ", ";
                 metricsName += "<b>" + this.$t("statsNaming." + metricList[1].code) + "</b>" + conjuction;
                 metricsName += "<b>" + this.$t("statsNaming." + metricList[2].code) + "</b>";
             }

             descriptionByMetrics = descriptionByMetrics.replace(keyWordToReplace, metricsName);
             descriptionByMetrics = descriptionByMetrics.replace(keyWordValueToReplace, metricsValue);
             //Remove ", respectivaly" word from description" beacause just one metric and there is no needed
             descriptionByMetrics = metricList.length > 1 ? descriptionByMetrics : descriptionByMetrics.replace(respectivelyWord, "");
         }

         descriptionReturn += descriptionByMetrics;
       });
       return descriptionReturn;
   },
   getDescriptionOverAverage(statsOverAverageList, leagueLabel) {

    let descriptionOverAverageSeason = "";
    let numberOfMetricsOverAverageSeason = statsOverAverageList.length;
    let code = numberOfMetricsOverAverageSeason > 1 ? "OverAverageSeasonMoreThanOne" : "OverAverageSeason";
    let metricsName = "";
    let metricsValue = "";
    let averageValue = "";
    let statUnits = "";
    let percentSymbol = "";
    let decimals = 2;
    //Need to change 'y' by 'e' when the last stat starts with 'I' (As Interceptions)
    let conjuction = numberOfMetricsOverAverageSeason > 1 && statsOverAverageList[numberOfMetricsOverAverageSeason - 1].code === "Interceptions" ? this.$t("playerRecruitment.radarDescription.conjuction2") : this.$t("playerRecruitment.radarDescription.conjuction");

    //Get all descriptions for OverAverageSeasonMoreThanOne or OverAverageSeason entry in Dictionary.js
    let radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription." + code));
    if(radarDescriptionList && radarDescriptionList.length > 0){
        descriptionOverAverageSeason = radarDescriptionList[this.player.playerId % radarDescriptionList.length].replace("league_name", leagueLabel);
    }

    //If there is 5 or more stats, order descending by pctOverAverageSeason and just take the first 4
    if(numberOfMetricsOverAverageSeason > MAX_NUMBER_STATS_OVER_AVERAGE_VALUE){
        statsOverAverageList.sort((a, b) => (a.pctOverAverageSeason > b.pctOverAverageSeason) ? -1 : 1);
        //Take first 4
        statsOverAverageList = statsOverAverageList.slice(0, MAX_NUMBER_STATS_OVER_AVERAGE_VALUE);
        numberOfMetricsOverAverageSeason = MAX_NUMBER_STATS_OVER_AVERAGE_VALUE;
    }

    if(numberOfMetricsOverAverageSeason > 1){
        let overAverageStatsText = "";
        //Get all descriptions for OverAverageStats entry in Dictionary.js
        radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription." + "OverAverageStats"));
        if(radarDescriptionList && radarDescriptionList.length > 0){
            overAverageStatsText = radarDescriptionList[this.player.playerId % radarDescriptionList.length];
        }

        for (var i = 0; i < numberOfMetricsOverAverageSeason; i++) {
          metricsName = "<b>" + this.$t("statsNaming." + statsOverAverageList[i].code) + "</b>";
          decimals = statsOverAverageList[i].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
          metricsValue = "<b>" + round(statsOverAverageList[i].valueToShow, decimals);
          statUnits = statsOverAverageList[i].unitCode ? statsOverAverageList[i].unitCode : "";
          percentSymbol = statsOverAverageList[i].isPercentage ? "%" : "";
          metricsValue += statUnits + percentSymbol + "</b>";
          averageValue = "<b>" + statsOverAverageList[i].averageValueOfSeason + statUnits + percentSymbol + "</b>";

          descriptionOverAverageSeason += overAverageStatsText
                  .replace("over_average_metric_name", metricsName)
                  .replace("over_average_metric_value", metricsValue)
                  .replace("average_metric_value", averageValue);

          if(i < numberOfMetricsOverAverageSeason - 2){
              descriptionOverAverageSeason += ", ";
          }else if(i === numberOfMetricsOverAverageSeason - 2){
              //Add conjuction here (second to last)
              descriptionOverAverageSeason += conjuction;
          }
        }

    }else{
        //If just one metric over average
        metricsName = "<b>" + this.$t("statsNaming." + statsOverAverageList[0].code) + "</b>";
        decimals = statsOverAverageList[0].valueToShow > VALUE_OVER_WHICH_JUST_ONE_DECIMAL ? 1 : 2;
        metricsValue += "<b>" + round(statsOverAverageList[0].valueToShow, decimals);
        metricsValue += (statsOverAverageList[0].unitCode ? " " + statsOverAverageList[0].unitCode : "");
        metricsValue += (statsOverAverageList[0].isPercentage ? "%" : "") + "</b>";
        averageValue = "<b>" + statsOverAverageList[0].averageValueOfSeason + "%" + "</b>";

        descriptionOverAverageSeason = descriptionOverAverageSeason
                .replace("over_average_metric_name", metricsName)
                .replace("over_average_metric_value", metricsValue)
                .replace("average_metric_value", averageValue);
    }

    descriptionOverAverageSeason += ".<br><br>";

    return descriptionOverAverageSeason;
  },
  getDescriptionByBottomValues(metricsUnderMin) {

    let descriptionUnderMinValue = "";
    let numberOfMetricsUnderMin = metricsUnderMin.length;
    let metricsName = "";
    let percentToReplace = "10%";
    let conjuction = metricsUnderMin[numberOfMetricsUnderMin - 1].code === "Interceptions" ? this.$t("playerRecruitment.radarDescription.conjuction2") : this.$t("playerRecruitment.radarDescription.conjuction");

    //Get all descriptions for UnderMinValue entry in Dictionary.js
    let radarDescriptionList = Object.values(this.$t("playerRecruitment.radarDescription.UnderMinValue"));
    if(radarDescriptionList.length > 0){
        //PlayerId % radarDescriptionList.length to take always the same description to the same player
        descriptionUnderMinValue = radarDescriptionList[this.player.playerId % radarDescriptionList.length];
    }

    //If there is 5 or more stats, order descending by pctValueOverMax and just take the first 4
    if(numberOfMetricsUnderMin > MAX_NUMBER_STATS_UNDER_MIN_VALUE){
        metricsUnderMin.sort((a, b) => (a.isPctValueUnderMin > b.isPctValueUnderMin) ? -1 : 1);
        //Take first 4
        metricsUnderMin = metricsUnderMin.slice(0, MAX_NUMBER_STATS_UNDER_MIN_VALUE);
        numberOfMetricsUnderMin = MAX_NUMBER_STATS_UNDER_MIN_VALUE;
    }

    metricsUnderMin.forEach((metric, index) => {
      if(index < numberOfMetricsUnderMin - 2){
        metricsName += "<b>" + this.$t("statsNaming." + metric.code) + "</b>" + ", ";
      }else if(index === numberOfMetricsUnderMin - 2){
        //Add conjuction here (second to last)
        metricsName += "<b>" + this.$t("statsNaming." + metric.code) + "</b>" + conjuction;
      }else{
        percentToReplace = metricsUnderMin[0].code === "TacklesWasDribbled" ? "5%" : "10%";
        metricsName += "<b>" + this.$t("statsNaming." + metric.code) + "</b>";
      }
    });

    descriptionUnderMinValue = descriptionUnderMinValue.replace("under_min_metric_name", metricsName).replace("percent_metric_name", percentToReplace);
    descriptionUnderMinValue += ".<br><br>";

    return descriptionUnderMinValue;
  },
  getFieldPositionIdByDefaultCode(position) {
    return getFieldPositionIdByDefaultCode(position);
  },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/base/RadarDescription.vue